"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdReactRouter = require("cccisd-react-router");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _InfoBar = _interopRequireDefault(require("./InfoBar"));
var _ResourceFromUrlModal = _interopRequireDefault(require("./ResourceFromUrlModal"));
var _ResourceTabs = _interopRequireDefault(require("./ResourceTabs"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppDefs = window.cccisd.appDefs;

/** Resource Center Package */
var CccisdLaravelResources = /*#__PURE__*/function (_React$Component) {
  function CccisdLaravelResources() {
    _classCallCheck(this, CccisdLaravelResources);
    return _callSuper(this, CccisdLaravelResources, arguments);
  }
  _inherits(CccisdLaravelResources, _React$Component);
  return _createClass(CccisdLaravelResources, [{
    key: "render",
    value: function render() {
      var _AppDefs$resourceCent, _config;
      var _this$props = this.props,
        config = _this$props.config,
        handle = _this$props.handle,
        location = _this$props.location,
        match = _this$props.match;
      if (!config && AppDefs !== null && AppDefs !== void 0 && (_AppDefs$resourceCent = AppDefs.resourceCenters) !== null && _AppDefs$resourceCent !== void 0 && _AppDefs$resourceCent.list) {
        config = AppDefs.resourceCenters.list.find(function (rc) {
          return rc.id === handle;
        });
      }
      if (!config) {
        return /*#__PURE__*/_react["default"].createElement("div", null, "There is no resource center config for handle \"".concat(handle, "\""));
      }

      // Needs to be rendered using path="/:tab?/:id?" or else Share link won't work
      var _ref = (match === null || match === void 0 ? void 0 : match.params) || {},
        tab = _ref.tab,
        id = _ref.id;

      // initial tab might be a query param in URL, like "?tab=Foo%20Bar"
      if (!tab) {
        var urlSearchParams = new URLSearchParams(location.search);
        tab = urlSearchParams.get('tab');
      }

      // don't set an initial tab that doesn't exist
      if (tab && !(((_config = config) === null || _config === void 0 ? void 0 : _config.tabs) || []).some(function (tabConfig) {
        return tabConfig.tag === tab;
      })) {
        tab = null;
      }
      var _config2 = config,
        displayOptions = _config2.displayOptions;
      if (this.props.hideShareButton) {
        (0, _set2["default"])(displayOptions, 'resources.showShareButton', false);
      }
      var renderTitle = function renderTitle() {
        if (config.showTitle) {
          return config.pageTitle ? /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: config.pageTitle
          }) : /*#__PURE__*/_react["default"].createElement("h1", null, config.title);
        }
        return null;
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: displayOptions.portal && displayOptions.portal.titleColor ? {
          color: displayOptions.portal.titleColor
        } : {},
        className: _style["default"].appdefsResources
      }, renderTitle(), /*#__PURE__*/_react["default"].createElement(_InfoBar["default"], {
        config: config
      }), /*#__PURE__*/_react["default"].createElement(_ResourceTabs["default"], {
        addToCollection: this.props.addToCollection,
        collection: this.props.collection,
        displayOptions: config.displayOptions,
        id: config.id,
        initialTab: tab,
        removeFromCollection: this.props.removeFromCollection,
        addToCollectionButtonLabel: this.props.addToCollectionButtonLabel,
        renderResourceTiles: this.props.renderResourceTiles,
        showTabs: config.showTabs,
        tabs: config.tabs,
        tags: config.tags,
        preventLayoutChange: this.props.preventLayoutChange
      }), !Number.isNaN(parseInt(id, 10)) && /*#__PURE__*/_react["default"].createElement(_ResourceFromUrlModal["default"], {
        resourceId: parseInt(id, 10),
        config: config
      }));
    }
  }]);
}(_react["default"].Component);
_defineProperty(CccisdLaravelResources, "propTypes", {
  handle: _propTypes["default"].string,
  renderResourceTiles: _propTypes["default"].func,
  match: _propTypes["default"].object,
  config: _propTypes["default"].object,
  hideShareButton: _propTypes["default"].bool,
  collection: _propTypes["default"].array,
  addToCollection: _propTypes["default"].func,
  removeFromCollection: _propTypes["default"].func,
  addToCollectionButtonLabel: _propTypes["default"].string,
  preventLayoutChange: _propTypes["default"].bool,
  /* From withRouter */
  location: _propTypes["default"].object
});
var _default = exports["default"] = (0, _cccisdReactRouter.withRouter)(CccisdLaravelResources);